<script>
import CategoryFilter from './CollectionFilterCategory';
import ProductTypeFilter from './CollectionFilterProductType';

export default {
  components: {
    CategoryFilter,
    ProductTypeFilter,
  },
  props: {
    selectedCategory: Object,
    selectedProductType: String,
    categories: Object,
    productTypes: Array,
  },
};
</script>

<template lang='pug'>
div
  category-filter(
    v-if='categories',
    :selected-category='selectedCategory',
    :categories='categories',
    @update-state='$emit("update-state", $event)',
    @get-campaigns='$emit("get-campaigns")',
  )
  product-type-filter(
    :selected-product-type='selectedProductType',
    :product-types='productTypes',
    :categories='categories',
    @update-state='$emit("update-state", $event)',
    @get-campaigns='$emit("get-campaigns")',
  )
</template>

<style>
@import '~import/index';
</style>